import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import Icon from '../partials/Icon';

import { useSessionProfile } from '../../warehouse/utils/permissions';
import { UI_COLORS } from '../../constants';

// Warehouse-section navigation: replaces the admin nav (Active Batches,
// Order Shipments, etc) on ported warehouse pages. Workflow links appear
// only for the permissions the logged-in warehouse user has - matching
// the RN app's hidden tabs.
const WarehouseNav = () => {
  const navigate = useNavigate();
  const path = window.location.pathname;
  const { loaded, permissions } = useSessionProfile();

  const links = [
    { url: '/', text: 'Home', icon: 'house', show: true },
    { url: '/warehouse/app/picking', text: 'Picking', icon: 'basket', show: permissions.picker },
    { url: '/warehouse/app/packing', text: 'Packing', icon: 'box-seam', show: permissions.packer },
    { url: '/warehouse/app/returns', text: 'Returns', icon: 'arrow-counterclockwise', show: permissions.stock_return },
    { url: '/warehouse/app/profile', text: 'Profile', icon: 'person', show: true },
  ];

  const isActive = (url) => {
    if (url === '/') return path === '/';
    return path === url || path.startsWith(`${url}/`);
  };

  return (
    <nav className="warehouse-nav" aria-label="Warehouse">
      <div className="flex-container" style={{ 'padding-left': '40px', 'border-bottom': `2px solid ${UI_COLORS.header}` }}>
        { loaded && links.filter(link => link.show).map((link) => (
          <div className="flex-1" key={link.url}>
            <Link
              to={link.url}
              className={`nav-link${isActive(link.url) ? ' nav-link-active' : ''}`}
              aria-current={isActive(link.url) ? 'page' : undefined}
            >
              <Icon name={link.icon} className="header-icon-spacing" aria-hidden="true" />
              {link.text}
            </Link>
          </div>
        )) }
        <div className="flex-1">
          <button type="button" className="nav-link nav-button" onClick={() => navigate(-1)}>
            <Icon name="arrow-left" className="header-icon-spacing" aria-hidden="true" />
            Back
          </button>
        </div>
      </div>
    </nav>
  );
};

export default WarehouseNav;
